export default {"src":"/_next/static/media/soem-labs-logo-white.5c9e3341.svg","height":97,"width":561};